import {
  useMotionValueEvent,
  useScroll,
  useTransform,
  motion,
} from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { FeaturesSectionDemo } from "../FeatureSectionDemo";

interface TimelineEntry {
  title: string;
  content: React.ReactNode;
}

export const Timeline = ({ data }: { data: TimelineEntry[] }) => {
  const ref = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setHeight(rect.height);
    }
  }, [ref]);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(scrollYProgress, [0, 1], [0, height]);
  const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  return (
    <div className="w-full bg-white font-sans md:px-10" ref={containerRef}>
      <div className="max-w-7xl mx-auto pt-20 px-4 md:px-8 lg:px-10 flex-col justify-center items-center">
        <h2 className="text-6xl font-bold mb-4 text-[#16423C] ">
          Our process,your data, your results, your IP
        </h2>
        <p className="text-[#6A9C89] text-sm md:text-2xl ">
          At the end of the service, you'll receive a tool to interact with your
          model and access results, which are your intellectual property. Our AI
          pipeline ensures consistent quality of recycled compounds, leading to
          cost savings and sustainable plastic use. We only assist when
          fine-tuning the AI model with new data for formulation adjustments is
          needed.
        </p>
      </div>

      <FeaturesSectionDemo />
    </div>
  );
};
